/**
 * Application branding — the single place the app's name and logo are declared.
 *
 * `APP_LOGO_SRC` stays null, so the brand slot renders the application name as
 * text. Drop a logo into src/assets/ and point this at it and every layout
 * picks it up — the `.header-logo` sizing rule is already in place.
 */
export const APP_NAME = 'PropStudioOS';

export const APP_LOGO_SRC = null;

export const APP_LOGO_ALT = `${APP_NAME} logo`;
